import React, { useRef, useEffect, useState } from 'react'
import { shallowEqual, useSelector, connect, useDispatch } from 'react-redux'
import * as auth from './authRedux'
import { getUserByToken } from './authCrud'

/*
 * Validate the persisted session before the app renders.
 *
 * redux-persist rehydrates authToken/user from localStorage, but nothing
 * previously checked that the token was still valid - a stale or v1-shaped
 * session would render the app and then fail on the first API call. This
 * probes /api/auth/me once on boot and logs out cleanly if it is rejected.
 *
 * Ported from attendance-frontend/src/app/modules/Auth/_redux/authInit.js.
 */

const mapState = (state) => ({ auth: state.auth })
const connector = connect(mapState, auth.actions)

const AuthInit = (props) => {
	const didRequest = useRef(false)
	const dispatch = useDispatch()
	const [showSplashScreen, setShowSplashScreen] = useState(true)
	const authToken = useSelector(({ auth }) => auth.authToken, shallowEqual)
	const user = useSelector(({ auth }) => auth.user, shallowEqual)

	useEffect(() => {
		const requestUser = async () => {
			try {
				if (!didRequest.current) {
					const { data } = await getUserByToken()
					// The axios interceptor resolves 4xx rather than throwing, so
					// an invalid session surfaces as status 0 instead of a reject.
					if (!data || !data.status) {
						dispatch(props.logout())
					}
				}
			} catch (error) {
				if (!didRequest.current) {
					dispatch(props.logout())
				}
			} finally {
				setShowSplashScreen(false)
			}

			return () => (didRequest.current = true)
		}

		if (authToken && user) {
			requestUser()
		} else {
			dispatch(props.logout())
			setShowSplashScreen(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return showSplashScreen ? null : <>{props.children}</>
}

export default connector(AuthInit)
